module.exports = __webpack_public_path__ + "static/img/yycj_05.fd37a57.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronicDocuments/yycj_05.png
// module id = 1WLA
// module chunks = 2